/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import FilterModule from 'app/mixins/FilterModule.js';
import SortModule from 'app/mixins/SortModule.js';
import * as _ from 'underscore';
import Utilities from 'app/utility/Utilities.js';


export const automatedRoutes = (state = defaultState.automatedRoutes, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0,
        j = 0,
        routes = [],
        getRouteTypeCount = (routes) => {
            let inputAggregate = {},
                i = 0,
                j = 0,
                input = null,
                name = null,
                inputTotal = 0,
                inputCount = [];

            // Walk the route collection and aggregate the counts
            // of each type of input (feed, twitter, insta, etc)
            for (i = 0; i < routes.length; i++){
                for (j = 0; j < routes[i].inputs.length; j++) {
                    input = routes[i].inputs[j];

                    // first check for a subtype
                    if (input.subtype) {
                        if (!inputAggregate[input.subtype]) {
                            inputAggregate[input.subtype] = 0;
                        }
                        inputAggregate[input.subtype]++;
                        inputTotal++;
                        continue;
                    }

                    // check if the particular input count has been initialized
                    if (!inputAggregate[input.type]) {
                        inputAggregate[input.type] = 0;
                    }

                    inputAggregate[input.type]++;
                    inputTotal++;
                }
            }

            // create an array of objects to be consumed by the filter drop down:
            // { type: 'Twitter', count: 1 }
            for (let key in inputAggregate) {
                if (key !== "") {
                    inputCount.push({
                        type: key,
                        count: inputAggregate[key]
                    });
                }
            }

            if (inputCount.length > 1) {
                inputCount.push({
                    'type': '',
                    count: inputTotal
                });
            }

            return inputCount;
        };

    switch (action.type) {
        case constants.UTILITIES_FILTER_STORE:
            if (action.store === 'routes') {
                nextState.filter = {
                    key: action.filter,
                    value: action.value,
                    exact: action.exact
                };
                nextState.filteredList = FilterModule(nextState.list, action.filter, action.value, action.exact);
                // when filtering for feed type be sure to remove subtypes (i.e. pinterest)
                if (action.value == 100) {
                    nextState.filteredList = _.filter(nextState.filteredList, function(route) {
                        for (var i = 0; i < route.inputs.length; ++i) {
                            if (route.inputs[i].subtype) {
                                return false;
                            }
                        }
                        return true;
                    });
                }
            }
            break;

        case constants.UTILITIES_SORT_STORE:
            if (action.store === 'routes') {
                nextState.sort = {
                    key: action.key,
                    direction: action.direction
                };
                nextState.list = SortModule(nextState.list, action.key, action.direction);
                if (nextState.filteredList.length > 0) {
                    nextState.filteredList = SortModule(nextState.filteredList, action.key, action.direction);
                }
            }
            break;

        case constants.UTILITIES_CLEAR_FILTER:
            if (action.store === 'routes') {
                nextState.filteredList = [];
            }
            break;

        case constants.ROUTE_LIST:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.list = action.payload;
                nextState.types = getRouteTypeCount(nextState.list);
            }
            break;

        case constants.ROUTE_SHOW:
        case constants.ROUTE_UPDATE:
            if (action.status === constants.STATE_SUCCESS) {
                if (nextState.list.length) {
                    for (i = 0; i < nextState.list.length; ++i) {
                        if (parseInt(nextState.list[i].id, 10) === parseInt(action.payload.id, 10)) {
                            nextState.list[i] = action.payload;
                            break;
                        }
                    }
                } else {
                    nextState.list.push(action.payload);
                }
            }
            break;

        case constants.ROUTE_DELETE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (nextState.list[i].id != action.payload.id) {
                        routes.push(nextState.list[i]);
                    }
                }
                nextState.list = routes;
            }
            break;

        case constants.ROUTE_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.list.push(action.payload);
            }
            break;

        case constants.INPUT_SHOW:
        case constants.INPUT_UPDATE:
        case constants.INPUT_REFRESH:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    let inputs = nextState.list[i].inputs;
                    for (j = 0; j < inputs.length; ++j) {
                        if (parseInt(inputs[j].id, 10) === parseInt(action.payload.id, 10)) {
                            inputs[j] = action.payload;
                            break;
                        }
                    }
                }
            }
            break;

        case constants.INPUT_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].igID, 10) === parseInt(action.payload.igID, 10)) {
                        nextState.list[i].inputs.push(action.payload);
                        break;
                    }
                }
            }
            break;

        case constants.INPUT_DELETE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].igID, 10) === parseInt(action.payload.igID, 10)) {
                        let inputs = nextState.list[i].inputs,
                            nextInputs = [];
                        for (j = 0; j < inputs.length; ++j) {
                            if (parseInt(inputs[j].id, 10) !== parseInt(action.payload.id, 10)) {
                                nextInputs.push(inputs[j]);
                            }
                        }
                        nextState.list[i].inputs = nextInputs;
                    }
                }
            }
            break;

        case constants.INPUT_VALIDATE:
            if (action.status === constants.STATE_SUCCESS) {
                action.payload.inputValid = true;
                if (action.payload.igID) {
                    for (i = 0; i < nextState.list.length; ++i) {
                        if (parseInt(nextState.list[i].rID, 10) === parseInt(action.payload.rID, 10)) {
                            let inputs = nextState.list[i].inputs;
                            for (j = 0; j < inputs.length; ++j) {
                                if (parseInt(inputs[j].id, 10) === parseInt(action.payload.id, 10)) {
                                    inputs[j] = action.payload;
                                    break;
                                }
                            }
                        }
                    }
                }
                nextState.validInputs.push(action.payload);
            } else {
                nextState.validInputs = [];
            }
            break;

        case constants.INPUT_CLEAR_VALIDATION:
            nextState.validInputs = [];
            break;

        case constants.INPUT_LOG:
            if (action.status === constants.STATE_SUCCESS) {
                if (_.findWhere(nextState.logs, {'id': action.payload.id}) !== undefined) {
                    for (i = 0; i < nextState.logs.length; ++i) {
                        if (parseInt(nextState.logs[i].id, 10) === parseInt(action.payload.id, 10)) {
                            nextState.logs[i] = action.payload;
                            break;
                        }
                    }
                } else {
                    nextState.logs.push(action.payload);
                }
            }
            break;

        case constants.INPUT_LIST_SOCIAL_CREDS:
            if (action.status === constants.STATE_SUCCESS) {
                nextState.socialInputCreds = action.payload;
            }
            break;

        case constants.OUTPUT_SHOW:
        case constants.OUTPUT_UPDATE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].ogID, 10) === parseInt(action.payload.ogID, 10)) {
                        for (j = 0; j < nextState.list[i].outputs.length; ++j) {
                            if (parseInt(nextState.list[i].outputs[j].id, 10) === parseInt(action.payload.id, 10)) {
                                nextState.list[i].outputs[j] = action.payload;
                                break;
                            }
                        }
                    }
                }
            }
            break;

        case constants.OUTPUT_DELETE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].ogID, 10) === parseInt(action.payload.ogID, 10)) {
                        let outputs = nextState.list[i].outputs,
                            nextOutputs = [];
                        for (j = 0; j < outputs.length; ++j) {
                            if (parseInt(outputs[j].id, 10) !== parseInt(action.payload.id, 10)) {
                                nextOutputs.push(outputs[j]);
                            }
                        }
                        nextState.list[i].outputs = nextOutputs;
                    }
                }
            }
            break;

        case constants.OUTPUT_CREATE:
            if (action.status === constants.STATE_SUCCESS) {
                for (i = 0; i < nextState.list.length; ++i) {
                    if (parseInt(nextState.list[i].ogID, 10) === parseInt(action.payload.ogID, 10)) {
                        nextState.list[i].outputs.push(action.payload);
                        break;
                    }
                }
            }
            break;

        // i know, i know, but since the flag gets set in every place a social is listed, when it
        // gets updated we need to update it here to so statuses update correctly
        // for example on the route list page
        case constants.SOCIAL_GET_FB_GROUP_STATUS:
			if (action.status === constants.STATE_SUCCESS) {
				for (i = 0; i < nextState.list.length; ++i) {
                    for (let j = 0; j < nextState.list[i].outputs.length; ++j) {
                        if (parseInt(nextState.list[i].outputs[j].social.id, 10) === parseInt(action.payload.id, 10)) {
    	                    nextState.list[i].outputs[j].social.hasGroupApp = action.payload.hasGroupApp;
    	                    break;
    	                }
                    }

				}
			}
			break;

        default:
            break;
    }

    return nextState;
};
